import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/my-pic.jpeg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              As a <b className="purple">Solution Engineer</b>, my focus is on
              engineering robust cloud-native security pipelines and
              implementing zero-trust architectures. I specialize in identifying
              vulnerabilities across complex multi-cloud environments{" "}
              <i>
                <b className="purple">
                  -including AWS, Azure, and Oracle Cloud—
                </b>
              </i>{" "}
              and translating those findings into actionable, compliant
              solutions.
              <br />
              <br />
              I’m proficient in
              <i>
                <b className="purple">
                  {" "}
                  <b className="purple">
                    {" "}
                    Kubernetes, Linux, CI/CD, JavaScript, ReactJs, NextJs,
                    TypeScript, NodeJs, Python, Terraform
                  </b>{" "}
                </b>
              </i>
              — and I enjoy Developing, Deploying, and Securing applications.
              <br />
              <br />
              My key areas of interest include
              <i>
                <b className="purple">
                  {" "}
                  DevOps, DevSecOps, ASPM, CSPM, KSPM, CWPP,{" "}
                </b>
              </i>
              and exploring new ways to automate security within enterprise
              pipelines.
              <br />
              <br />
              Whenever possible, I love building projects with
              <b className="purple"> Node.js </b> and modern frameworks like{" "}
              <i>
                <b className="purple">React.js</b> and{" "}
                <b className="purple">Next.js</b>.
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
